import {
  Typography,
  Card,
  Box,
  Button,
  FormControl,
  Stack,
  MenuItem,
  InputLabel,
  Select,
  CardContent,
  Autocomplete,
  TextField,
  CardHeader,
} from "@mui/material";

import MemberQueryQRCardPrintList from "../../components/app/MemberQueryQRCardPrintList";
import MockData from "../../helper/MockData";
import { useState, useEffect, useRef } from "react";
import { InfoApi } from "../../api/InfoApi";
import { toast } from "react-toastify";
import { RttRounded } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";
import { AdminApi } from "../../api/AdminApi";

export default function MemberQueryCardSection() {
  const [queryResult, setQueryResult] = useState(null);
  const [userType, setUserType] = useState(0);
  const [organizationList, setOrganizationList] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState(0);

  const componentToPrint = useRef(null);

  useEffect(() => {
    // toast.info("useEffect is called");
    // setQueryResult(MockData.getMemberQueryResult());
    AdminApi.getOrgnizationListCallback((isSuccess, msg, data) => {
      // if (isSuccess) {
      //     setOrganizationList(data);
      // } else {
      // console.debug("result: isSuccess=", isSuccess,
      //     " msg=", msg, " data=", data);

      if (isSuccess === false) {
        toast.error(msg);
        setOrganizationList(false);
        return;
      }

      // Remove the public option, data[0].id = 0
      data = data.filter((org) => org.id !== 0);

      setOrganizationList(data);
      if (data.length > 0) {
        // se(data[0].id);
      }
      //}
    });
  }, []);

  const hasOrganizationList = organizationList ? true : false;

  const userTypeList = [
    { value: "school", label: "學校" },
    { value: "public", label: "公眾" },
  ];
  const userTypeSelectionItems = organizationList ? (
    organizationList.map((item) => {
      return (
        <MenuItem key={item.id} value={item.id}>
          {item.name_zh} / {item.name_en}{" "}
        </MenuItem>
      );
    })
  ) : (
    <> </>
  );
  //let queryResult = MockData.getMemberQueryResult();

  const onUserTypeChanged = (event) => {
    setUserType(event.target.value);
  };

  // const handlePrint = async () => {
  // };
  const handlePrint = useReactToPrint({
    content: () => componentToPrint.current,
  });

  const handleQuery = async () => {
    if(selectedOrgId === 0){
      // toast.error("請選擇機構");
      return;
    }

    const filters = [{ field: "organization_id", value: selectedOrgId, op: "eq" }];



    const result = await InfoApi.queryMembers(1, -1, filters);
    console.debug("result: ", result);
    if (result === false) {
      //alert("Success");
      toast.error("Failed to query members");
      return;
    }
    setQueryResult(result);
    // setOrganizationList(result);
    // toast
  };

  return (
    <Stack>
      <Box sx={{ px: 0 }}>
        <Card>
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              {/* <pre>
                            {organizationList ? JSON.stringify(organizationList, null, 2) : "not ready"}
                        </pre> */}
              {hasOrganizationList && (
                <>
                  {/* <FormControl fullWidth> */}
                  {/* <InputLabel id="eventID-label">機構列表</InputLabel> */}
                  <Autocomplete
                    disablePortal={false}
                    id="organization-list"
                    options={organizationList}
                    getOptionLabel={(option) =>
                      `${option.name_zh}`
                    }
                    sx={{ width: '100%' }}
                    PopperProps={{ sx: { zIndex: 2000 } }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="機構列表"
                        variant="outlined"
                        placeholder=""
                      />
                    )}
                    label="機構列表"
                    // value={null}
                    value={
                      organizationList.find(
                        (org) => org.id === selectedOrgId
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setSelectedOrgId(newValue ? newValue.id : 0);
                    }}
                  />
                  {/* <Select
                      labelId="userType-label"
                      id="userType"
                      value={userType}
                      label="用戶類型"
                      onChange={onUserTypeChanged}
                    >
                      {userTypeSelectionItems}
                    </Select> */}
                  {/* </FormControl> */}
                  {/* <pre>{selectedOrgId}</pre> */}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleQuery}
                  >
                    查詢
                  </Button>
                  <Button
                    variant="contained"
                    disabled={queryResult == null}
                    color="info"
                    onClick={handlePrint}
                  >
                    打印
                  </Button>
                </>
              )}
            </Stack>
          </CardContent>
        </Card>
      </Box>
      <Box sx={{ height: 16 }}></Box>
      <MemberQueryQRCardPrintList
        memberQueryResult={queryResult}
        componentToPrint={componentToPrint}
        pageSize={1000}
      />
    </Stack>
  );
}
